export const filterTypes = {
  team: ['phase'],
  player: ['phase', 'teamId'],
};
